import { getDataBrowserClearDsdCacheUrl, getDsdUrl } from "../../../constants/urls";
import { getRequest, postRequest } from "../../../middlewares/api/actions";

export const UPDATE_DATABROWSER_DSD_CACHE_LIST_DSDS_READ = "UPDATE_DATABROWSER_DSD_CACHE_LIST_DSDS_READ"
export const UPDATE_DATABROWSER_DSD_CACHE_DELETE = " UPDATE_DATABROWSER_DSD_CACHE_DELETE"
export const UPDATE_DATABROWSER_DSD_CACHE_ANNOTATIONS_SHOW = "UPDATE_DATABROWSER_DSD_CACHE_ANNOTATIONS_SHOW"
export const UPDATE_DATABROWSER_DSD_CACHE_ANNOTATIONS_HIDE = "UPDATE_DATABROWSER_DSD_CACHE_ANNOTATIONS_HIDE"

export const readDsdsListDsds = () => getRequest(
  UPDATE_DATABROWSER_DSD_CACHE_LIST_DSDS_READ,
  getDsdUrl()
);

export const deleteDataBrowserDsdCache = (dsdIdsList) => postRequest(
  UPDATE_DATABROWSER_DSD_CACHE_DELETE,
  getDataBrowserClearDsdCacheUrl(),
  dsdIdsList,
  t => ({
    success: t('scenes.dataManager.updateDatabrowserDsdCache.messages.delete.success')
  })
);

export const showDsdsListDsdLayoutAnnotations = (annotations, triplet) => ({
  type: UPDATE_DATABROWSER_DSD_CACHE_ANNOTATIONS_SHOW,
  annotations,
  triplet
});

export const hideDsdsListDsdLayoutAnnotations = () => ({
  type: UPDATE_DATABROWSER_DSD_CACHE_ANNOTATIONS_HIDE
});
